import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";

import bike from "../../assets/icones/bike.svg";
import groupe from "../../assets/icones/groupe.svg";
import smile from "../../assets/icones/smile.svg";
import time from "../../assets/icones/time.svg";

const iconByKey = {
  groupe,
  time,
  bike,
  smile,
};

const AccompagnementSection = () => {
  const { t } = useTranslation("informations/AccompagnementSection");

  const steps = t("steps", { returnObjects: true });

  return (
    <Box sx={{ display: "flex", justifyContent: "center", px: 2, mt: 10 }}>
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: "1200px",
          borderRadius: "20px",
          px: { xs: 3, md: 6 },
          pt: { xs: 4, md: 6 },
          pb: { xs: 5, md: 6 },
          backgroundColor: "#F8F8F8",
          fontFamily: "'Poppins', sans-serif",
          boxSizing: "border-box",
        }}
      >
        {/* Titre */}
        <Typography
          sx={{
            fontWeight: 900,
            fontSize: { xs: "2rem", md: "2.8rem" },
            mb: 5,
            textAlign: "left",
            color: "#000",
          }}
        >
          {t("title.part1")}{" "}
          <Box component="span" sx={{ color: "#449F2D" }}>
            {t("title.highlight")}
          </Box>
        </Typography>

        {/* Layout principal */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 4,
          }}
        >
          {/* Colonne gauche - texte */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              pr: { md: 4 },
              pb: { xs: 4, md: 0 },
            }}
          >
            <Typography sx={{ fontSize: "1.1rem", lineHeight: 1.9, color: "#000" }}>
              {t("lede.a")}{" "}
              <Box component="span" fontWeight="bold">
                {t("lede.brand")}
              </Box>
              {t("lede.b")}{" "}
              <Box component="span" fontWeight="bold">
                {t("lede.personal")}
              </Box>
              {t("lede.c")}{" "}
              {t("lede.d")}{" "}
              <Box component="span" fontWeight="bold">
                {t("lede.simplify")}
              </Box>
              {t("lede.e")}
            </Typography>
          </Box>

          {/* Colonne droite - timeline */}
          <Box
            sx={{
              flex: 2,
              position: "relative",
              pl: { xs: 4, md: 6 },
            }}
          >
            {/* Ligne verticale */}
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 24,
                width: "1px",
                height: "100%",
                backgroundColor: "#449F2D",
              }}
            />

            {/* Étapes */}
            {steps.map((step, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  mb: index === 0 ? 8 : 5,
                  position: "relative",
                }}
              >
                <Box
                  component="img"
                  src={iconByKey[step.iconKey] || groupe}
                  alt={step.title}
                  sx={{
                    width: 48,
                    height: 48,
                    position: "relative",
                    mr: 2,
                  }}
                />
                <Box>
                  <Typography
                    sx={{
                      fontWeight: 800,
                      fontSize: "1.05rem",
                      mb: 0.5,
                      color: "#000",
                    }}
                  >
                    {step.title}
                  </Typography>
                  <Typography sx={{ fontSize: "0.95rem", color: "#444" }}>
                    {step.desc}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default AccompagnementSection;